import React from "react"
import { graphql, useStaticQuery } from "gatsby"

import FundamentalsBadge from "../images/microsoft-certified-fundamentals-badge.svg"
import AssociateBadge from "../images/microsoft-certified-associate-badge.svg"
import ExpertBadge from "../images/microsoft-certified-expert-badge.svg"

function Badge({ type, className }) {
    switch (type) {
        case "microsoft-certified-associate":
            return <img src={AssociateBadge} alt="Microsoft Certified Associate" className={className} />
        case "microsoft-certified-expert":
            return <img src={ExpertBadge} alt="Microsoft Certified Expert" className={className} />
        case "microsoft-certified-fundamentals":
            return <img src={FundamentalsBadge} alt="Microsoft Certified Fundamentals" className={className} />
        default:
            return <></>
    }
}

export default function Certifications({ className }) {
  const data = useStaticQuery(graphql`
    query Certifications {
      allMarkdownRemark(
        filter: { fileAbsolutePath: { regex: "/certifications/" } }
        sort: { fields: fileAbsolutePath }
      ) {
        edges {
          node {
            html
            frontmatter {
              title
              icon
            }
          }
        }
      }
    }
  `)
  const { allMarkdownRemark } = data
  const { edges } = allMarkdownRemark

  return (
    <section id="certifications" className={`${className} py-4`}>
        <h1 className="text-center">Certifications</h1>
        <div className="container mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 mx-8 p-4 lg:px-0">
            {edges.map((edge, i) => (
                <article key={i} className="p-8 border-2 border-gray-700 rounded-lg shadow-xl text-center">
                    <h2>{edge?.node?.frontmatter?.title}</h2>
                    <Badge type={edge?.node?.frontmatter?.icon} className="w-48 my-4 mx-auto" />
                    <div dangerouslySetInnerHTML={{ __html: edge.node.html }}></div>
                </article>
            ))}
        </div>
    </section>
  )
}